import { render, staticRenderFns } from "./property-user-favourites.vue?vue&type=template&id=47658b7e&scoped=true&v-if=idToken&"
import script from "./property-user-favourites.vue?vue&type=script&lang=ts&"
export * from "./property-user-favourites.vue?vue&type=script&lang=ts&"
import style0 from "./property-user-favourites.vue?vue&type=style&index=0&id=47658b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47658b7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
